import { CaseIncludedField } from "app/area/case-report/case-listing/types";
import { FieldItem, FieldValue } from "app/area/reports/types";

export const fieldValueToFieldItem = (field: FieldValue, children?: CaseIncludedField[], entityTypePath?: string[],
  search?: boolean): FieldItem => {
  return {
    value: field.v,
    description: search ? (field.pad ? field.pad + ' - ' : '') + field.d : field.d,
    parentAllLevelsDescription: field.pad,
    entityTypePath,
    descendants: !!children ? children.map(item => fieldValueToFieldItem(item.domain, item.children, item.entityTypePath,
      search)) : undefined
  };
};
